
export default {
  computed: {
    siteType () {
      return this.$store.state.siteType
    }
  }
}
